(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cabinet-browser-full"] && !Shopify.designMode) return;
  try {
    class CabinetBrowserFull{constructor(root){this.root=root;this.cards=[...root.querySelectorAll('[data-cbf-card]')];this.buttons=[...root.querySelectorAll('[data-cbf-type]')];this.search=root.querySelector('[data-cbf-search]');this.clear=root.querySelector('[data-cbf-clear]');this.count=root.querySelector('[data-cbf-count]');this.empty=root.querySelector('[data-cbf-empty]');this.activeTitle=root.querySelector('[data-cbf-active-title]');this.selects={width:root.querySelector('[data-cbf-dimension="width"]'),height:root.querySelector('[data-cbf-dimension="height"]'),depth:root.querySelector('[data-cbf-dimension="depth"]')};this.state={type:root.dataset.defaultType||'base',width:'',height:'',depth:'',search:''};this.prepare();this.bind();this.render()}prepare(){this.cards.forEach(card=>{const text=[card.dataset.title,card.dataset.productType,card.dataset.category,card.dataset.tags].join(' ');card.dataset.cbfType=this.classify(text);const dims=this.getDims(card);card.dataset.cbfWidth=dims.width;card.dataset.cbfHeight=dims.height;card.dataset.cbfDepth=dims.depth;const out=card.querySelector('[data-cbf-dim-output]');if(out)out.textContent=this.formatDims(dims)})}bind(){this.buttons.forEach(btn=>btn.addEventListener('click',()=>{this.state.type=btn.dataset.cbfType;this.state.width='';this.state.height='';this.state.depth='';this.render()}));Object.entries(this.selects).forEach(([key,select])=>select&&select.addEventListener('change',()=>{this.state[key]=select.value;this.render(false)}));if(this.search)this.search.addEventListener('input',()=>{this.state.search=this.search.value.trim().toLowerCase();this.render(false)});if(this.clear)this.clear.addEventListener('click',()=>{this.state={type:this.root.dataset.defaultType||'base',width:'',height:'',depth:'',search:''};if(this.search)this.search.value='';this.render()});this.root.querySelectorAll('[data-cbf-minus]').forEach(btn=>btn.addEventListener('click',()=>this.qty(btn,-1)));this.root.querySelectorAll('[data-cbf-plus]').forEach(btn=>btn.addEventListener('click',()=>this.qty(btn,1)));this.root.querySelectorAll('[data-cbf-add]').forEach(btn=>btn.addEventListener('click',()=>this.add(btn)))}classify(text){text=(text||'').toLowerCase();if(text.includes('vanity'))return'vanity';if(text.includes('tall')||text.includes('pantry')||text.includes('oven cabinet'))return'tall';if(text.includes('wall')||text.includes('upper')||text.includes('bridge'))return'wall';if(text.includes('base')||text.includes('sink')||text.includes('drawer')||text.includes('trash')||text.includes('microwave')||text.includes('easy reach'))return'base';return'trim'}getDims(card){const value=String(card.dataset.dimensions||'').trim();const match=value.match(/^(\d+(?:\.\d+)?)W\s*x\s*(\d+(?:\.\d+)?)D\s*x\s*(\d+(?:\.\d+)?)H$/i);return match?{width:match[1],depth:match[2],height:match[3]}:{width:'',depth:'',height:''}}clean(v){return String(v||'').replace(/[^0-9.]/g,'')}match(text,rx){const m=text.match(rx);return m?m[1]:''}formatDims(d){return[d.width&&`${d.width}W`,d.depth&&`${d.depth}D`,d.height&&`${d.height}H`].filter(Boolean).join(' x ')}render(rebuild=true){this.buttons.forEach(btn=>btn.classList.toggle('is-active',btn.dataset.cbfType===this.state.type));const label={base:'Base Cabinets',wall:'Wall Cabinets',tall:'Tall Cabinets',trim:'Trim, Details & Others',vanity:'Vanity Cabinets'}[this.state.type]||'Cabinets';if(this.activeTitle)this.activeTitle.textContent=label;if(rebuild)this.buildSelects();let shown=0;this.cards.forEach(card=>{const visible=this.matches(card);card.hidden=!visible;if(visible)shown++});if(this.count)this.count.textContent=shown;if(this.empty)this.empty.hidden=shown>0}buildSelects(){['width','height','depth'].forEach(key=>{const select=this.selects[key];if(!select)return;const label=select.options[0].textContent;const values=[...new Set(this.cards.filter(c=>c.dataset.cbfType===this.state.type).map(c=>c.dataset[`cbf${key[0].toUpperCase()+key.slice(1)}`]).filter(Boolean))].sort((a,b)=>Number(a)-Number(b));select.innerHTML=`<option value="">${label}</option>`+values.map(v=>`<option value="${v}">${v}${key==='width'?'W':key==='height'?'H':'D'}</option>`).join('');select.value=this.state[key]||''})}matches(card){if(card.dataset.cbfType!==this.state.type)return false;if(this.state.width&&card.dataset.cbfWidth!==this.state.width)return false;if(this.state.height&&card.dataset.cbfHeight!==this.state.height)return false;if(this.state.depth&&card.dataset.cbfDepth!==this.state.depth)return false;if(this.state.search&&!card.dataset.search.includes(this.state.search))return false;return true}qty(btn,delta){const card=btn.closest('[data-cbf-card]');const input=card&&card.querySelector('[data-cbf-qty]');if(input)input.value=Math.max(1,Number(input.value||1)+delta)}async add(btn){const card=btn.closest('[data-cbf-card]');const qty=card&&card.querySelector('[data-cbf-qty]');btn.disabled=true;const old=btn.textContent;btn.textContent='Adding...';try{const res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:btn.dataset.variantId,quantity:Number(qty&&qty.value||1)})});if(!res.ok)throw new Error();btn.textContent='Added';document.dispatchEvent(new CustomEvent('cart:refresh'));document.dispatchEvent(new CustomEvent('cart:updated'));setTimeout(()=>btn.textContent=old,1400)}catch(e){btn.textContent='Could not add';setTimeout(()=>btn.textContent=old,1600)}finally{setTimeout(()=>btn.disabled=false,300)}}}document.querySelectorAll('[data-cabinet-browser-full]').forEach(root=>new CabinetBrowserFull(root));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cabinet-browser"] && !Shopify.designMode) return;
  try {
    
  class CabinetCollectionBrowser {
    constructor(section) {
      this.section = section;
      this.cards = Array.from(section.querySelectorAll('[data-product-card]'));
      this.typeButtons = Array.from(section.querySelectorAll('[data-type-filter]'));
      this.subtypeList = section.querySelector('[data-subtype-list]');
      this.searchInput = section.querySelector('[data-cabinet-search]');
      this.activeTypeTitle = section.querySelector('[data-active-type-title]');
      this.visibleCount = section.querySelector('[data-visible-count]');
      this.emptyState = section.querySelector('[data-empty-state]');
      this.cartMessage = section.querySelector('[data-cart-message]');
      this.clearButton = section.querySelector('[data-clear-filters]');
      this.dimensionSelects = Array.from(section.querySelectorAll('[data-dimension-filter]'));
      this.modal = section.querySelector('[data-product-modal]');
      this.modalMedia = section.querySelector('[data-modal-media]');
      this.modalTitle = section.querySelector('[data-modal-title]');
      this.modalSku = section.querySelector('[data-modal-sku]');
      this.modalStock = section.querySelector('[data-modal-stock]');
      this.modalPrice = section.querySelector('[data-modal-price]');
      this.modalDescription = section.querySelector('[data-modal-description]');
      this.modalDimensions = section.querySelector('[data-modal-dimensions]');
      this.modalQtyInput = section.querySelector('[data-modal-qty-input]');
      this.modalAddButton = section.querySelector('[data-modal-add-to-cart]');
      this.state = {
        type: section.dataset.defaultType || 'base',
        subtype: '',
        width: '',
        height: '',
        depth: '',
        search: '',
        page: 1
      };
      this.cardsPerPage = 24;
      this.pagination = section.querySelector('[data-browser-pagination]');

      this.typeLabels = {
        base: 'Base Cabinets',
        wall: 'Wall Cabinets',
        tall: 'Tall Cabinets',
        trim: 'Trim, Details, & Others',
        vanity: 'Vanity Cabinets'
      };

      this.subtypes = {
        base: ['Base Cabinet', 'Sink Base', 'Drawer Base', 'Blind Door', 'Trash Pullout', 'Microwave', 'Easy Reach', 'Corner Sink', 'Other'],
        wall: ['Wall Cabinet', 'Blind Door', 'Corner Wall', 'Deep Refrigerator', 'Glass Door', 'Easy Reach', 'Wall Tower', 'Other'],
        tall: ['Pantry', 'Oven', 'Oven Panel', 'Tall Cabinet', 'Other'],
        trim: ['Filler', 'Panel', 'Molding', 'Toe Kick', 'Shelf', 'Decorative Door Panel', 'Scribe', 'Skin Panel', 'Other'],
        vanity: ['Vanity Sink Base', 'Vanity Cabinet', 'Sink Base', 'Drawer Base', 'Other']
      };

      this.prepareCards();
      this.bind();
      this.render();
    }

    prepareCards() {
      this.cards.forEach((card) => {
        const text = this.cardText(card);
        const type = this.classifyType(card, text);
        const dimensions = this.extractDimensions(card, type);
        card.dataset.type = type;
        card.dataset.subtype = this.classifySubtype(type, card, text);
        card.dataset.width = dimensions.width;
        card.dataset.height = dimensions.height;
        card.dataset.depth = dimensions.depth;

        const output = card.querySelector('[data-dimension-output]');
        if (output && dimensions.display) {
          output.textContent = dimensions.display;
          output.hidden = false;
        }
      });
    }

    cardText(card) {
      return `${card.dataset.category || ''} ${card.dataset.productType || ''} ${card.dataset.tags || ''} ${card.dataset.title || ''}`.toLowerCase();
    }

    hasAny(text, terms) {
      return terms.some((term) => text.includes(term));
    }

    normalizeDimension(value) {
      const raw = String(value || '').replace(/["']/g, '').trim();
      if (!raw) return '';
      const match = raw.match(/\d+(?:\.\d+)?/);
      if (!match) return '';
      const number = Number.parseFloat(match[0]);
      if (!Number.isFinite(number)) return '';
      return Number.isInteger(number) ? String(number) : String(number).replace(/0+$/, '').replace(/\.$/, '');
    }

    extractDimensions(card) {
      const dimensions = String(card.dataset.dimensions || '').trim();
      const match = dimensions.match(/^((?:\d+(?:\.\d+)?)|(?:\.\d+))W\s*x\s*((?:\d+(?:\.\d+)?)|(?:\.\d+))D\s*x\s*((?:\d+(?:\.\d+)?)|(?:\.\d+))H$/i);
      if (!match) {
        return { width: '', height: '', depth: '', display: '' };
      }

      return {
        width: match[1],
        depth: match[2],
        height: match[3],
        display: `${match[1]}W x ${match[2]}D x ${match[3]}H`
      };
    }

    classifyType(card, text) {
      const category = (card.dataset.category || '').toLowerCase();

      if (category.includes('vanity')) return 'vanity';
      if (this.hasAny(text, [' vanity sink base', ' vanity cabinet', ' vanity cabinets', ' vanity '])) return 'vanity';
      if (category.includes('tall')) return 'tall';
      if (category.includes('trim') || category.includes('accessories')) return 'trim';
      if (category.includes('wall')) return 'wall';
      if (category.includes('base')) return 'base';

      if (this.hasAny(text, [' tall cabinets', ' tall cabinet', ' pantry cabinet', ' oven cabinet'])) return 'tall';
      if (this.hasAny(text, [' trim & accessories', ' cabinet accessories', ' accessory', ' accessories', ' trim ', ' molding', ' moulding', ' filler', ' panel', ' touch up', ' touch-up', ' touchup', ' spray can', ' putty', ' roll out', ' spice', ' wine rack', ' cutlery'])) return 'trim';
      if (this.hasAny(text, [' wall cabinets', ' wall cabinet', ' wall '])) return 'wall';
      if (this.hasAny(text, [' base cabinets', ' base cabinet', ' base ', ' sink base', ' microwave cabinet', ' drawer base'])) return 'base';
      return 'base';
    }

    classifySubtype(type, card, text) {
      const tags = ` ${card.dataset.tags || ''} `.toLowerCase();
      const exact = ` ${card.dataset.category || ''} ${card.dataset.productType || ''} ${card.dataset.tags || ''} ${card.dataset.title || ''} `.toLowerCase();

      if (type === 'base') {
        if (this.hasAny(exact, [' sink base cabinet', ' sink base ', ' sinkbase'])) return 'Sink Base';
        if (this.hasAny(exact, [' drawer base cabinet', ' drawer base ', ' drawer cabinet'])) return 'Drawer Base';
        if (this.hasAny(exact, [' trash can base cabinet', ' trash pullout cabinet', ' trash pullout', ' trash can '])) return 'Trash Pullout';
        if (this.hasAny(exact, [' corner sink front', ' corner sink '])) return 'Corner Sink';
        if (this.hasAny(exact, [' blind base cabinet', ' blind door', ' blind '])) return 'Blind Door';
        if (this.hasAny(exact, [' microwave cabinet', ' microwave '])) return 'Microwave';
        if (this.hasAny(exact, [' easy reach cabinet', ' easy reach '])) return 'Easy Reach';
        if (this.hasAny(exact, [' base cabinet', ' base cabinets', ' base '])) return 'Base Cabinet';
        return 'Other';
      }

      if (type === 'wall') {
        if (this.hasAny(exact, [' glass door cabinet', ' glass door ', ' glass '])) return 'Glass Door';
        if (this.hasAny(exact, [' blind wall cabinet', ' blind door', ' blind '])) return 'Blind Door';
        if (this.hasAny(exact, [' corner wall cabinet', ' corner cabinet', ' corner wall '])) return 'Corner Wall';
        if (this.hasAny(exact, [' wall tower with drawers', ' wall tower '])) return 'Wall Tower';
        if (this.hasAny(exact, [' easy reach cabinet', ' easy reach '])) return 'Easy Reach';
        if (this.hasAny(exact, [' deep wall refrigerator cabinet', ' refrigerator wall', ' refrigerator cabinet', ' deep wall ', ' deep '])) return 'Deep Refrigerator';
        if (this.hasAny(exact, [' wall cabinet', ' wall cabinets', ' wall '])) return 'Wall Cabinet';
        return 'Other';
      }

      if (type === 'tall') {
        if (this.hasAny(exact, [' oven cabinet overlay panel', ' overlay panel'])) return 'Oven Panel';
        if (this.hasAny(exact, [' oven cabinet', ' oven '])) return 'Oven';
        if (this.hasAny(exact, [' pantry cabinet', ' pantry '])) return 'Pantry';
        return 'Other';
      }

      if (type === 'trim') {
        if (this.hasAny(exact, [' filler'])) return 'Filler';
        if (this.hasAny(exact, [' decorative door panel', ' dwp'])) return 'Decorative Door Panel';
        if (this.hasAny(exact, [' skin panel', ' skin '])) return 'Skin Panel';
        if (this.hasAny(exact, [' panel'])) return 'Panel';
        if (this.hasAny(exact, [' molding', ' moulding'])) return 'Molding';
        if (this.hasAny(exact, [' toe kick', ' tks'])) return 'Toe Kick';
        if (this.hasAny(exact, [' shelf'])) return 'Shelf';
        if (this.hasAny(exact, [' scribe'])) return 'Scribe';
        return 'Other';
      }

      if (type === 'vanity') {
        if (this.hasAny(exact, [' vanity sink base', ' vanity sink '])) return 'Vanity Sink Base';
        if (this.hasAny(exact, [' vanity cabinet', ' vanity cabinets', ' vanity '])) return 'Vanity Cabinet';
        if (this.hasAny(exact, [' sink base cabinet', ' sink base '])) return 'Sink Base';
        if (this.hasAny(exact, [' drawer base cabinet', ' drawer base ', ' drawer cabinet'])) return 'Drawer Base';
        return 'Other';
      }

      if (text.includes('sink')) return 'Sink Base';
      if (text.includes('drawer')) return 'Drawer Base';
      if (text.includes('double')) return 'Double Door';
      if (text.includes('single')) return 'Single Door';
      return 'Other';
    }

    bind() {
      this.typeButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.state.type = button.dataset.typeFilter;
          this.state.subtype = '';
          this.state.width = '';
          this.state.height = '';
          this.state.depth = '';
          this.state.page = 1;
          this.render();
        });
      });

      this.subtypeList.addEventListener('click', (event) => {
        const button = event.target.closest('[data-subtype-filter]');
        if (!button) return;
        this.state.subtype = this.state.subtype === button.dataset.subtypeFilter ? '' : button.dataset.subtypeFilter;
        this.state.page = 1;
        this.render();
      });

      this.dimensionSelects.forEach((select) => {
        select.addEventListener('change', () => {
          this.state[select.dataset.dimensionFilter] = select.value;
          this.state.page = 1;
          this.render(false);
        });
      });

      this.searchInput.addEventListener('input', () => {
        this.state.search = this.searchInput.value.trim().toLowerCase();
        this.state.page = 1;
        this.render(false);
      });

      this.clearButton.addEventListener('click', () => {
        this.state.type = this.section.dataset.defaultType || 'base';
        this.state.subtype = '';
        this.state.width = '';
        this.state.height = '';
        this.state.depth = '';
        this.state.search = '';
        this.state.page = 1;
        this.searchInput.value = '';
        this.render();
      });

      this.section.addEventListener('click', (event) => {
        const minus = event.target.closest('[data-qty-minus]');
        const plus = event.target.closest('[data-qty-plus]');
        const add = event.target.closest('[data-add-to-cart]');
        const openProduct = event.target.closest('[data-open-product]');
        const closeProduct = event.target.closest('[data-close-product]');
        const modalMinus = event.target.closest('[data-modal-qty-minus]');
        const modalPlus = event.target.closest('[data-modal-qty-plus]');
        const modalAdd = event.target.closest('[data-modal-add-to-cart]');

        if (minus || plus) {
          const row = event.target.closest('[data-product-card]');
          const input = row.querySelector('[data-qty-input]');
          const current = Number(input.value) || 1;
          input.value = minus ? Math.max(1, current - 1) : current + 1;
        }

        if (add) {
          this.addToCart(add);
        }

        if (openProduct) {
          this.openProductModal(openProduct.closest('[data-product-card]'));
        }

        if (closeProduct) {
          this.closeProductModal();
        }

        if (modalMinus || modalPlus) {
          const current = Number(this.modalQtyInput.value) || 1;
          this.modalQtyInput.value = modalMinus ? Math.max(1, current - 1) : current + 1;
        }

        const pageButton = event.target.closest('[data-browser-page]');
        if (pageButton) {
          this.state.page = Number(pageButton.dataset.browserPage) || 1;
          this.render(false);
          this.section.querySelector('[data-product-list]')?.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }

        if (modalAdd) {
          const quantity = Math.max(1, Number(this.modalQtyInput.value) || 1);
          this.addVariantToCart(modalAdd, Number(modalAdd.dataset.variantId), quantity);
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.closeProductModal();
        }
      });
    }

    render(rebuildOptions = true) {
      this.typeButtons.forEach((button) => {
        const isActive = button.dataset.typeFilter === this.state.type;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      this.activeTypeTitle.textContent = this.typeLabels[this.state.type] || '';
      this.renderSubtypeFilters();

      if (rebuildOptions) {
        this.buildDimensionOptions();
      }

      const matchingCards = this.cards.filter((card) => this.matches(card));
      const count = matchingCards.length;
      const totalPages = Math.max(1, Math.ceil(count / this.cardsPerPage));

      if (this.state.page > totalPages) this.state.page = totalPages;
      const start = (this.state.page - 1) * this.cardsPerPage;
      const visibleCards = new Set(matchingCards.slice(start, start + this.cardsPerPage));

      this.cards.forEach((card) => {
        card.hidden = !visibleCards.has(card);
      });

      this.visibleCount.textContent = count;
      this.emptyState.hidden = count > 0;
      this.renderPagination(totalPages);
    }

    renderPagination(totalPages) {
      if (!this.pagination) return;
      this.pagination.replaceChildren();
      this.pagination.hidden = totalPages <= 1;
      if (totalPages <= 1) return;

      const addButton = (label, page, current = false) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = current ? 'cabinet-pagination__page is-current' : 'cabinet-pagination__page';
        button.dataset.browserPage = String(page);
        button.textContent = label;
        if (current) button.setAttribute('aria-current', 'page');
        this.pagination.appendChild(button);
      };

      if (this.state.page > 1) {
        const previous = document.createElement('button');
        previous.type = 'button';
        previous.className = 'cabinet-pagination__link';
        previous.dataset.browserPage = String(this.state.page - 1);
        previous.textContent = 'Previous';
        this.pagination.appendChild(previous);
      }

      for (let page = 1; page <= totalPages; page += 1) {
        addButton(String(page), page, page === this.state.page);
      }

      if (this.state.page < totalPages) {
        const next = document.createElement('button');
        next.type = 'button';
        next.className = 'cabinet-pagination__link';
        next.dataset.browserPage = String(this.state.page + 1);
        next.textContent = 'Next';
        this.pagination.appendChild(next);
      }
    }

    renderSubtypeFilters() {
      const names = this.subtypes[this.state.type] || [];
      this.subtypeList.innerHTML = '';

      names.forEach((name) => {
        const count = this.cards.filter((card) => card.dataset.type === this.state.type && card.dataset.subtype === name).length;
        if (!count) return;

        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.subtypeFilter = name;
        button.textContent = `${name} (${count})`;
        button.classList.toggle('is-active', this.state.subtype === name);
        this.subtypeList.appendChild(button);
      });
    }

    buildDimensionOptions() {
      this.dimensionSelects.forEach((select) => {
        const key = select.dataset.dimensionFilter;
        const label = select.options[0].textContent;
        const values = this.cards
          .filter((card) => card.dataset.type === this.state.type)
          .map((card) => (card.dataset[key] || '').trim())
          .filter(Boolean)
          .filter((value, index, array) => array.indexOf(value) === index)
          .sort((a, b) => Number.parseFloat(a) - Number.parseFloat(b));

        select.innerHTML = '';
        const defaultOption = document.createElement('option');
        defaultOption.value = '';
        defaultOption.textContent = label;
        select.appendChild(defaultOption);

        values.forEach((value) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value.includes('"') ? value : `${value}"`;
          select.appendChild(option);
        });

        select.value = this.state[key] || '';
      });
    }

    matches(card) {
      if (card.dataset.type !== this.state.type) return false;
      if (this.state.subtype && card.dataset.subtype !== this.state.subtype) return false;
      if (this.state.width && card.dataset.width !== this.state.width) return false;
      if (this.state.height && card.dataset.height !== this.state.height) return false;
      if (this.state.depth && card.dataset.depth !== this.state.depth) return false;
      if (this.state.search && !(card.dataset.search || '').includes(this.state.search)) return false;
      return true;
    }

    openProductModal(card) {
      if (!card || !this.modal) return;

      const image = card.querySelector('.cabinet-product-row__image img, .cabinet-product-row__image svg');
      const dimensionOutput = card.querySelector('[data-dimension-output]');
      const stock = card.querySelector('.cabinet-product-row__stock');
      const price = card.querySelector('.cabinet-product-row__price');

      this.modalMedia.innerHTML = '';
      if (image) {
        this.modalMedia.appendChild(image.cloneNode(true));
      }

      this.modalTitle.textContent = card.dataset.displayTitle || '';
      this.modalSku.textContent = card.dataset.sku || '';
      this.modalSku.hidden = !card.dataset.sku;
      this.modalStock.textContent = stock ? stock.textContent : '';
      this.modalPrice.replaceChildren();
      if (price) {
        Array.from(price.childNodes).forEach((node) => {
          this.modalPrice.appendChild(node.cloneNode(true));
        });
      } else {
        this.modalPrice.textContent = card.dataset.price || '';
      }
      this.modalDescription.textContent = card.dataset.description || 'No description available.';

      this.modalQtyInput.value = '1';
      this.modalAddButton.dataset.variantId = card.querySelector('[data-add-to-cart]').dataset.variantId;
      this.modalAddButton.disabled = card.querySelector('[data-add-to-cart]').disabled;
      this.modalAddButton.textContent = this.modalAddButton.disabled ? 'Sold Out' : 'Add to Cart';

      this.modal.hidden = false;
      document.documentElement.classList.add('cabinet-modal-open');
      this.modalAddButton.focus();
    }

    closeProductModal() {
      if (!this.modal || this.modal.hidden) return;
      this.modal.hidden = true;
      document.documentElement.classList.remove('cabinet-modal-open');
    }

    addToCart(button) {
      const row = button.closest('[data-product-card]');
      const qtyInput = row.querySelector('[data-qty-input]');
      const quantity = Math.max(1, Number(qtyInput.value) || 1);
      this.addVariantToCart(button, Number(button.dataset.variantId), quantity);
    }

    addVariantToCart(button, variantId, quantity) {
      const sections = this.cartSections();

      button.disabled = true;
      button.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity,
          sections,
          sections_url: window.location.pathname
        })
      })
        .then((response) => {
          if (!response.ok) throw new Error('Cart add failed');
          return response.json();
        })
        .then((response) => {
          this.replaceRenderedSections(response.sections);
          return this.refreshCartUi().then((cart) => ({ cart, response }));
        })
        .then(({ cart, response }) => {
          this.cartMessage.textContent = 'Added to cart.';
          button.textContent = 'Added';
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, response } }));
          document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart } }));
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
          setTimeout(() => {
            button.disabled = false;
            button.textContent = 'Add to Cart';
            this.cartMessage.textContent = '';
          }, 1300);
        })
        .catch(() => {
          this.cartMessage.textContent = 'Could not add this item. Please try again.';
          button.disabled = false;
          button.textContent = 'Add to Cart';
        });
    }

    cartSections() {
      return [
        'cart-drawer',
        'cart-icon-bubble',
        'cart-notification',
        'header',
        'main-cart-items'
      ];
    }

    replaceRenderedSections(sections) {
      if (!sections) return;

      Object.entries(sections).forEach(([sectionId, html]) => {
        if (!html) return;

        const current = document.getElementById(`shopify-section-${sectionId}`);
        if (!current) return;

        const wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        const fresh = wrapper.querySelector(`#shopify-section-${sectionId}`);

        if (fresh) {
          current.innerHTML = fresh.innerHTML;
        }
      });
    }

    refreshCartUi() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((response) => response.json())
        .then((cart) => {
          this.updateCartCounts(cart);
          this.updateCartTotals(cart);
          return cart;
        });
    }

    formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }

      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: this.section.dataset.currency || 'USD'
      }).format((Number(cents) || 0) / 100);
    }

    updateCartCounts(cart) {
      const selectors = [
        '[data-cart-count]',
        '[data-cart-count-bubble]',
        '.cart-count-bubble span[aria-hidden="true"]',
        '.cart-count-bubble .cart-count',
        '#CartCount',
        '.cart-count'
      ];

      document.querySelectorAll(selectors.join(',')).forEach((node) => {
        node.textContent = cart.item_count;
        node.hidden = cart.item_count === 0;
      });

      document.querySelectorAll('.cart-count-bubble').forEach((node) => {
        node.hidden = cart.item_count === 0;
        node.classList.toggle('hidden', cart.item_count === 0);
      });
    }

    updateCartTotals(cart) {
      const total = this.formatMoney(cart.total_price);
      const selectors = [
        '[data-cart-total]',
        '[data-cart-subtotal]',
        '[data-cart-drawer-total]',
        '[data-cart-drawer-subtotal]',
        '.totals__subtotal-value',
        '.cart__subtotal',
        '.cart-subtotal__price',
        '.cart-drawer__subtotal',
        '.cart-drawer__total'
      ];

      document.querySelectorAll(selectors.join(',')).forEach((node) => {
        node.textContent = total;
      });
    }
  }

  document.querySelectorAll('[data-cabinet-browser]').forEach((section) => {
    if (section.dataset.browserReady) return;
    section.dataset.browserReady = 'true';
    new CabinetCollectionBrowser(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cabinet-line-shopping-collection"] && !Shopify.designMode) return;
  try {
    
  class CabinetShop {
    constructor(section) {
      this.section = section;
      this.products = Array.from(section.querySelectorAll('[data-cabinet-product]'));
      this.filters = Array.from(section.querySelectorAll('[data-cabinet-filter]'));
      this.search = section.querySelector('[data-cabinet-search]');
      this.clear = section.querySelector('[data-cabinet-clear]');
      this.count = section.querySelector('[data-cabinet-visible-count]');
      this.empty = section.querySelector('[data-cabinet-empty]');

      this.filters.forEach((filter) => filter.addEventListener('change', () => this.applyFilters()));

      if (this.search) {
        this.search.addEventListener('input', () => this.applyFilters());
      }

      if (this.clear) {
        this.clear.addEventListener('click', () => {
          this.filters.forEach((filter) => {
            filter.checked = false;
          });
          if (this.search) {
            this.search.value = '';
          }
          this.applyFilters();
        });
      }

      section.querySelectorAll('[data-qty-decrease]').forEach((button) => {
        button.addEventListener('click', () => this.changeQuantity(button, -1));
      });

      section.querySelectorAll('[data-qty-increase]').forEach((button) => {
        button.addEventListener('click', () => this.changeQuantity(button, 1));
      });

      section.querySelectorAll('[data-cabinet-add-form]').forEach((form) => {
        form.addEventListener('submit', (event) => this.addToCart(event));
      });
    }

    activeTypes() {
      return this.filters.filter((filter) => filter.checked).map((filter) => filter.value);
    }

    applyFilters() {
      const types = this.activeTypes();
      const query = this.search ? this.search.value.trim().toLowerCase() : '';
      let visibleCount = 0;

      this.products.forEach((product) => {
        const typeMatches = types.length === 0 || types.includes(product.dataset.productType);
        const searchMatches = query === '' || product.dataset.search.includes(query);
        const visible = typeMatches && searchMatches;
        product.hidden = !visible;

        if (visible) {
          visibleCount += 1;
        }
      });

      if (this.count) {
        this.count.textContent = visibleCount;
      }

      if (this.empty) {
        this.empty.hidden = visibleCount > 0;
      }

      if (this.clear) {
        this.clear.hidden = types.length === 0 && query === '';
      }
    }

    changeQuantity(button, delta) {
      const form = button.closest('form');
      const input = form ? form.querySelector('input[name="quantity"]') : null;

      if (!input) {
        return;
      }

      const nextValue = Math.max(1, Number(input.value || 1) + delta);
      input.value = nextValue;
    }

    async addToCart(event) {
      event.preventDefault();

      const form = event.currentTarget;
      const button = form.querySelector('button[type="submit"]');
      const message = form.querySelector('[data-cabinet-message]');
      const formData = new FormData(form);

      if (button) {
        button.disabled = true;
        button.dataset.originalText = button.textContent;
        button.textContent = 'Adding...';
      }

      if (message) {
        message.textContent = '';
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          },
          body: formData
        });

        if (!response.ok) {
          throw new Error('Unable to add item.');
        }

        if (message) {
          message.textContent = 'Added to cart';
        }

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (error) {
        if (message) {
          message.textContent = 'Could not add. Please try again.';
        }
      } finally {
        if (button) {
          button.disabled = false;
          button.textContent = button.dataset.originalText || 'Add to cart';
        }
      }
    }
  }

  document.querySelectorAll('[data-cabinet-shop]').forEach((section) => new CabinetShop(section));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cabinet-lines-collection-list"] && !Shopify.designMode) return;
  try {
    
  class CabinetLinesSection {
    constructor(section) {
      this.section = section;
      this.cards = Array.from(section.querySelectorAll('[data-cabinet-line-card]'));
      this.inputs = Array.from(section.querySelectorAll('[data-cabinet-lines-filter]'));
      this.count = section.querySelector('[data-cabinet-lines-count]');
      this.empty = section.querySelector('[data-cabinet-lines-empty]');
      this.clearButton = section.querySelector('[data-cabinet-lines-clear]');

      this.inputs.forEach((input) => input.addEventListener('change', () => this.filterCards()));

      if (this.clearButton) {
        this.clearButton.addEventListener('click', () => {
          this.inputs.forEach((input) => {
            input.checked = false;
          });
          this.filterCards();
        });
      }
    }

    selectedFilters() {
      return this.inputs.filter((input) => input.checked).map((input) => `${input.dataset.cabinetLinesFilter}-${input.value}`);
    }

    filterCards() {
      const selected = this.selectedFilters();
      let visibleCount = 0;

      this.cards.forEach((card) => {
        const cardFilters = card.dataset.filters || '';
        const isVisible = selected.every((filter) => cardFilters.includes(filter));
        card.hidden = !isVisible;

        if (isVisible) {
          visibleCount += 1;
        }
      });

      if (this.count) {
        this.count.textContent = visibleCount;
      }

      if (this.empty) {
        this.empty.hidden = visibleCount > 0;
      }

      if (this.clearButton) {
        this.clearButton.hidden = selected.length === 0;
      }
    }
  }

  document.querySelectorAll('.cabinet-lines').forEach((section) => new CabinetLinesSection(section));

  } catch(e) { console.error(e); }
})();
})();
